module.exports = __webpack_public_path__ + "static/media/sub-14.cb77aa27.jpg";